const getters = {
  getUserData: (state) => state.userData,
  getUserOtpData: (state) => state.userOtpData,
  getUserToken: (state) => state.userToken,
  getUserTokenRefresh: (state) => state.userTokenRefresh,
  getUserOrganizations: (state) => state.userOrganizations,
  getEmailActivation: (state) => state.emailActivation,
};

export default getters;
